import { AdaptableColumnContext, AdaptableOptions, QueryableColumnContext } from '@adaptabletools/adaptable-angular-aggrid';
import { ADAPTABLE_LICENSE } from '@unified-ui/global-licenses';
import { ReportLayoutNames } from 'libs/shared/components/src/lib/report-base/report-base.component';

export const defaultAdaptableOptions: AdaptableOptions = {
    primaryKey: 'id',
    licenseKey: ADAPTABLE_LICENSE,
    adaptableId: 'Report: AdaptableID is not being updated',
    entitlementOptions: {
        moduleEntitlements: [
            { adaptableModule: 'Alert', accessLevel: 'Hidden' },
            { adaptableModule: 'BulkUpdate', accessLevel: 'Hidden' },
            { adaptableModule: 'DataChangeHistory', accessLevel: 'Hidden' },
            { adaptableModule: 'DataSet', accessLevel: 'Hidden' },
            { adaptableModule: 'FlashingCell', accessLevel: 'Hidden' },
            { adaptableModule: 'PlusMinus', accessLevel: 'Hidden' },
            { adaptableModule: 'Shortcut', accessLevel: 'Hidden' },
            { adaptableModule: 'StateManagement', accessLevel: 'Hidden' },
            { adaptableModule: 'StatusBar', accessLevel: 'Hidden' },
            { adaptableModule: 'Theme', accessLevel: 'Hidden' },
            { adaptableModule: 'Note', accessLevel: 'Hidden' },
            { adaptableModule: 'DataImport', accessLevel: 'Hidden' },
            { adaptableModule: 'Schedule', accessLevel: 'Hidden' },
            { adaptableModule: 'Charting', accessLevel: 'Hidden' }
        ]
    },
    userInterfaceOptions: {
        showDocumentationLinks: false,
        showAdapTableVersion: false
        //showLoadingScreen: false,
    },
    exportOptions: {
        isColumnExportable: (exportableColumnContext: AdaptableColumnContext) => {
            return exportableColumnContext.column.columnId !== 'id';
        },
        systemReportNames: ['All Data', 'Current Layout', 'Selected Data'],
        systemExportDestinations: ['Download', 'Clipboard'],
        appendFileTimestamp: true,
        exportDataFormat: 'rawValue'
    },
    columnOptions: {
        showMissingColumnsWarning: false
    },
    initialState: {
        Layout: {
            Layouts: [
                {
                    Name: ReportLayoutNames.TABLE_LAYOUT,
                    TableColumns: [],
                    AutoSizeColumns: true,
                    SuppressAggFuncInHeader: true,
                    GrandTotalRow: 'pinnedBottom'
                },
                {
                    Name: ReportLayoutNames.PIVOT_LAYOUT,
                    PivotGroupedColumns: [],
                    PivotColumns: [],
                    PivotAggregationColumns: [],
                    SuppressAggFuncInHeader: true,
                    GrandTotalRow: 'pinnedBottom'
                }
            ]
        },
        Dashboard: {
            IsCollapsed: true,
            PinnedToolbars: ['Layout', 'Export'],
            IsFloating: false,
            IsInline: true
        },
        FormatColumn: {
            FormatColumns: [
                {
                    Tags: ['costRelated'],
                    Scope: {
                        // Cost Related IDS
                        ColumnIds: []
                    },
                    DisplayFormat: {
                        Formatter: 'NumberFormatter',
                        Options: {
                            FractionDigits: 2
                        }
                    }
                },
                {
                    Scope: {
                        DataTypes: ['number']
                    },
                    CellAlignment: 'Right',
                    DisplayFormat: {
                        Formatter: 'NumberFormatter',
                        Options: {
                            FractionDigits: 0
                        }
                    }
                }
            ]
        },
        QuickSearch: {
            CellMatchStyle: {
                ForeColor: '#FFFDFA',
                BackColor: '#0161FE'
            }
        },
        StatusBar: {
            StatusBars: [
                {
                    Key: 'Center Panel',
                    StatusBarPanels: ['SystemStatus']
                }
            ]
        }
    },
    dashboardOptions: {
        showQuickSearchInHeader: true,
        canFloat: false
    },
    quickSearchOptions: {
        quickSearchPlaceholder: 'Quick Search'
    },
    settingsPanelOptions: {
        navigation: {
            items: ['CalculatedColumn', 'ColumnInfo', 'Charting', 'ColumnFilter', 'CustomSort', 'Dashboard', 'DataImport', 'Export', 'FormatColumn', 'GridInfo', 'GridFilter', 'Layout', 'NamedQuery', 'Schedule', 'StatusBar', 'StyledColumn', 'QuickSearch']
        }
    },
    expressionOptions: {
        displayColumnFriendlyNamesForExpressions: true,
        isColumnQueryable: (queryableColumnContext: QueryableColumnContext) => {
            return queryableColumnContext.column.columnId !== 'id';
        }
    }
};
